import React from "react";
import MaskedInput from 'react-text-mask';

const TextMaskSnils = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/]}
      placeholderChar={'_'}
      showMask
    />
  );
}

export default TextMaskSnils;
